import { render, staticRenderFns } from "./Emotion.vue?vue&type=template&id=5a515543&scoped=true&"
import script from "./Emotion.vue?vue&type=script&lang=js&"
export * from "./Emotion.vue?vue&type=script&lang=js&"
import style0 from "./Emotion.vue?vue&type=style&index=0&id=5a515543&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a515543",
  null
  
)

export default component.exports